import axios from "axios";
import Config from "../../Config";
import { useSelector } from "react-redux";
import { useEffect, useState } from "react";
import { useMutation } from "react-query";
import { Bg, BoxContainer, Underline } from "../../Components/Styles/PageStyles";
import Images from "../../Images";
import Navbar from "../../Components/Navbar";
import tw from "tailwind-styled-components";
import Table from "../../Components/DuesLogs/Table";
import NotFoundModel from "../../Components/NotFoundModel";
import Loading from "../../Components/Loading";
import { useTranslation } from "react-i18next";
import moment from "moment";
import {
    FieldWrapper,
    InputGroup,
    Label,
} from "../../Components/Styles/InputStyles";
import { Field, Form, Formik } from "formik";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";

export const DuesLogs=()=>{

    const user = useSelector((state) => state.UserReducer.user)
    const [apiData, setApiData] = useState();
    const [selectedData, setSelectedData] = useState();
    const [filterValue, setFilterValue] = useState("");
    const [filter, setFilter] = useState("1");
    const [startDate, setStartDate] = useState(
        moment(new Date()).format("YYYY-MM-DD")
    );
    const {t} =useTranslation();

    const initialValues = {
        name: "",
        filterVal: filterValue,
        startDate: moment(new Date()).format("YYYY-MM-DD"),
    };


    const fetchFunction =async()=>{
        const body = new FormData();
        body.append("date",startDate);

        return await axios.post(`${Config.apiUrl}/getmonthlyduelogs`,body,{
            headers: {
                authorization: "Bearer " + user.token,
                "Content-Type": "application/x-www-form-urlencoded; charset=UTF-8",
            },
        });
    }

    const getDuesLogsSuccess = (res) => {
        const response = res.data;

        if (response.msg === "No data found") {
            setApiData([]);
            return;
        }

        const records = response.already_exist_records || [];

        const formattedData =
            records.length > 0
            ? records.map((log) => ({
                date: response.date,
                summary: log,
                // already_exist_count: response.already_exist_count,
                }))
            : [
                {
                    date: response.date || "--",
                    summary: "--",
                    // already_exist_count: response.already_exist_count || "--"
                },
                ];
        setApiData(formattedData);
    };

    const getDuesLogsError = (res)=>{}

    const {
        isLoading: isLoading,
        mutate: getDuesLogs,
        error,
        data,
        isRefetching,
    }=useMutation(fetchFunction,{
        onSuccess: getDuesLogsSuccess,
        onError: getDuesLogsError,
    });

    useEffect(() => {
        const handler = setTimeout(() => {
            getDuesLogs();
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [ startDate]);

    const submitHandler = (values) => {
        const newValues = {
            startDate: moment(values.startDate).format("YYYY-MM-DD"), 
        };
        setStartDate(newValues.startDate);
    };
    const ChangeHandler = (e) => {
        setFilterValue(e.target.value);
    };


    return(
        <>
          <Bg
            style={{
                backgroundImage:`url(${Images.BeamsBg})`,
                backgroundRepeat:"no-repeat",
                backgroundSize: "contain",
                backgroundPosition: "top left",
                height: "100vh",
            }}
          >
          <Navbar />

          <BoxContainer>
            <div className="flex w-full justify-between items-center">
                <div>
                    <Title>
                        {t("Dues Logs")}
                    </Title>
                    <Underline />
                </div>
            </div>

            <div className="flex w-full justify-between items-center">
                <Filters
                    submitHandler={submitHandler}
                    initialValues={initialValues}
                    InitialLoading={isLoading}
                    setFilterValue={setFilterValue}
                    ChangeHandler={ChangeHandler}
                    filter={filter}
                    setFilter={setFilter}
                    filterValue={filterValue}
                    user={user}
                    t={t}
                />
            </div>

            {(!error && !isLoading) && data && (
                <TableWrapper>
                    <Table
                    ApiData={apiData || []}
                    userType={user.userType}
                    setSelectedData={setSelectedData}
                    selectedData={selectedData}
                    />
                    {(error || data?.data?.msg === "No data found") && !isLoading && (
                        <NotFoundModel />
                    )}
                </TableWrapper>
            )}
            {(isLoading || isRefetching) && <Loading />}
          </BoxContainer>
          </Bg>
        </>
    )
}

const Filters = ({
    initialValues,
    submitHandler,
    InitialLoading,
    setFilter,
    filter,
    setFilterValue,
    filterValue,
    t,
}) => {
    const today = moment().format("YYYY-MM-DD");
    return (
        <Formik initialValues={initialValues} onSubmit={submitHandler}>
            <Form className="w-full">
                <FilterContainer>
                    <div className="flex gap-2 items-end sm:text-base text-xs flex-wrap">
                        <div className="flex items-end gap-2">
                            <InputGroup className="max-w-[200px]">
                                <Label htmlFor="startDate">{("Date")}:</Label>
                                <FieldWrapper className="h-10">
                                    <img
                                        src={Images.Calender}
                                        alt="Calender icon"
                                        className="w-3.5"
                                    />
                                    <Field
                                        type="date"
                                        name="startDate"
                                        id="startDate"
                                        className="ml-1"
                                        max={today}
                                    />
                                </FieldWrapper>
                            </InputGroup>
                        </div>
                        <ApplyBtn disabled={InitialLoading} type="submit">
                            {t("Date_filter")}
                        </ApplyBtn>
                    </div>
                    <InputGroup
                        className="min-w-[120px]"
                        style={{ flexBasis: "content" }}
                    >
                        <Label htmlFor="filterVal">{("Log By")}:</Label>
                        <Select
                            autoComplete="off"
                            className="w-25 px-2 bg-transparent text-sm border-none"
                            style={{ height: "40px" }}
                            value={filter}
                            onChange={(e) => {
                                setFilter(e.target.value);
                                setFilterValue("");
                            }}
                        >
                            <MenuItem value="1">Dues Logs</MenuItem>
                            <MenuItem value="2">Rental Cycle</MenuItem>
                        </Select>
                    </InputGroup>
                </FilterContainer>
            </Form>
        </Formik>
    );
};

const Title = tw.h1`text-xl  text-gray-800 whitespace-nowrap font-medium`;
const TableWrapper = tw.h1`my-10 border bg-white rounded-md`
const ApplyBtn = tw.button`${(p) =>
    p.$active
        ? "bg-gray-100"
        : ""} border whitespace-nowrap border-gray-200 flex space-x-1.5 justify-center items-center text-white h-full rounded-md px-6  cursor-pointer bg-primary-color hover:bg-hover-color  py-2.5 text-sm`;
const FilterContainer = tw.div`flex items-end flex-wrap justify-between gap-4 mt-8`;
